import request from '@/utils/request';

export function login(username: string, password: string) {
  return request({
    url: '/Login',
    method: 'post',
    data: {
      username,
      password
    },
  });
}

// export function getUserInfo(organizationId: any) {
//   return request({
//     url: '/Login/Organization',
//     method: 'get',
//     params: { organizationId },
//   });
// }

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post',
  });
}

export function updatePassWord(username: any, password: any, oldPassword: any) {
  return request({
    url: '/Login/Password',
    method: 'put',
    data: {
      username,
      password,
      oldPassword
    }
  })
}

const API_URL: string = '/Login'
export function loginForm(uesMethod: string, params: ParamsInfo | any | null, data: any[] | DataInfo | null, funName: string = '') {
  return request({
    url: API_URL + funName,
    method: uesMethod,
    params,
    data
  });
}

export interface DataInfo {
  organizationId?: any
  userName?: string
  password?: any
}

export interface ParamsInfo {
  organizationId?: any
  pageNum?: number
  pageSize?: number
}
